import { Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'mojo-full-page-widget',
    templateUrl: './full-page-widget.component.html',
    standalone: false
})
export class FullPageWidgetComponent implements OnInit {

  @Input()
  containerClasses: string;

  constructor() { }

  ngOnInit() {
  }

  getContainerClasses() {
    return 'full-page-widget ' + this.containerClasses;
  }

}
